import React from "react";
import { showToast } from "../../../../utils/Toastify";
import ProductCatSwiper from "./ProductCatSwiper";

const Product = () => {
  let count = [1, 2, 3, 4];

  return (
    <div className="h-full prodLinea lg:h-[650px]">
      <div className="mx-auto max-w-2xl py-7 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 md:text-5xl mb-10">
          Explore popular categories
        </h2>
        <ProductCatSwiper />
      </div>
    </div>
  );
};

export default Product;
